import { css } from '@emotion/react'
import { Cell, Grid, HFlow, Icon } from 'bold-ui'
import { Form, FormDebouncedValueSpy, SwitchField, TextField } from 'components/form'
import { PopperButton, PopperControls } from 'components/popper'
import { FormState } from 'final-form'
import { useFilterCounter } from 'hooks/useFilterCounter'
import { Dispatch, SetStateAction } from 'react'
import { metaPath } from 'util/metaPath'

import { AtividadeColetivaGruposFilterFormModel } from '../grupos/model-atividadeColetivaGrupos'
import { AtividadeColetivaGruposFilterPopperForm } from './AtividadeColetivaGruposFilterPopperForm'

const path = metaPath<AtividadeColetivaGruposFilterFormModel>()

interface AtividadeColetivaGruposFilterFormProps {
  filter: AtividadeColetivaGruposFilterFormModel
  onChangeFilter: Dispatch<SetStateAction<AtividadeColetivaGruposFilterFormModel>>
}

export const AtividadeColetivaGruposFilterForm = (props: AtividadeColetivaGruposFilterFormProps) => {
  const { filter, onChangeFilter } = props

  const countAppliedFilter = useFilterCounter(filter, {
    pageParams: false,
  })

  const renderPopper = (controls: PopperControls) => (
    <AtividadeColetivaGruposFilterPopperForm filter={filter} onChangeFilter={onChangeFilter} onClose={controls.close} />
  )

  const handleChange = (formState: FormState<AtividadeColetivaGruposFilterFormModel>) => {
    onChangeFilter({
      ...formState.values,
    })
  }

  const renderForm = () => {
    return (
      <Grid gapVertical={0.1}>
        <FormDebouncedValueSpy onChange={handleChange} />

        <Cell size={4}>
          <TextField
            name={path.nomeGrupo}
            placeholder='Buscar por nome do grupo'
            icon='zoomOutline'
            style={styles.ellipsis}
          />
        </Cell>

        <Cell size={3}>
          <SwitchField style={styles.switch} name={path.isSomenteRegistrosProprios} label='Ver somente meus grupos' />
        </Cell>

        <Cell size={5}>
          <HFlow justifyContent='flex-end'>
            <PopperButton
              kind='primary'
              size='small'
              skin='default'
              placement='bottom-end'
              renderPopper={renderPopper}
              focusOnOpen={false}
            >
              <Icon icon='filterOutline' />
              {'Filtros' + (countAppliedFilter > 0 ? ` (${countAppliedFilter})` : '')}
            </PopperButton>
          </HFlow>
        </Cell>
      </Grid>
    )
  }

  return <Form<AtividadeColetivaGruposFilterFormModel> initialValues={filter} render={renderForm} />
}

const styles = {
  ellipsis: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  fonte: css`
    margin-bottom: 0.5rem;
  `,
  switch: css`
    padding-top: 0.25rem;
  `,
}
